import { render, staticRenderFns } from "./EmailAddressList.vue?vue&type=template&id=156ded58&scoped=true"
import script from "./EmailAddressList.vue?vue&type=script&lang=js"
export * from "./EmailAddressList.vue?vue&type=script&lang=js"
import style0 from "./EmailAddressList.vue?vue&type=style&index=0&id=156ded58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156ded58",
  null
  
)

export default component.exports